module.exports = __webpack_public_path__ + "static/media/Big Background.07b1a178.jpg";